<template>
    <div class="external-page external-alt sb-l-c sb-r-c">
        <div id="main" class="animated fadeIn">
            <section id="content_wrapper">
                <section id="content">

                    <div class="admin-form theme-info mw500" id="">
                        <div class="row table-layout">
                            <a href="/"><b>5LIFE</b>system</a>
                        </div>
                        <div class="panel mt30 mb25">
                            <form @submit.prevent="submit">

                                <div class="panel-body bg-light p25 pb15" >
                                    <div class="section">
                                        <label for="form-email-or-login" class="field-label text-muted fs18 mb10">Имя пользователя или email</label>
                                        <label for="form-email-or-login" class="field prepend-icon">
                                            <input v-model.trim="$v.form.emailOrLogin.$model" type="text" id="form-email-or-login" class="gui-input" placeholder="Введите email" autocomplete="off">
                                            <label for="form-email-or-login" class="field-icon">
                                                <i class="fa fa-user"></i>
                                            </label>
                                        </label>
                                    </div>

                                    <div class="section">
                                        <label for="form-password" class="field-label text-muted fs18 mb10">Пароль</label>
                                        <label for="form-password" class="field prepend-icon">
                                            <input v-model.trim="$v.form.password.$model" type="password" id="form-password" class="gui-input" placeholder="Введите пароль">
                                            <label for="form-password" class="field-icon">
                                                <i class="fa fa-lock"></i>
                                            </label>
                                        </label>
                                    </div>
                                    <div class="alert alert-danger" role="alert" v-if="$v.form.$error === true">
                                        <span class="glyphicon glyphicon-exclamation-sign"></span>
                                        Заполните все поля
                                    </div>
                                    <div class="alert alert-danger" role="alert" v-if="form.authError === true">
                                        <span class="glyphicon glyphicon-exclamation-sign"></span>
                                        Неправильный логин или пароль
                                    </div>
                                </div>
                                <div class="panel-footer clearfix text-center">
                                    <button type="submit" class="button btn-primary auth_action">Вход</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import Auth from "../../classes/Auth";
    import AuthApi from '../../classes/api/Auth';

    export default {
        mixins: [validationMixin],
        data() {
            return {
                form: {
                    emailOrLogin: '',
                    password: '',
                    authError: false,
                },
            };
        },
        validations: {
            form: {
                emailOrLogin: {
                    required,
                },
                password: {
                    required,
                },
            },
        },
        methods: {
            submit() {
                this.$v.$touch();
                this.form.authError = false;
                if (this.$v.$invalid) {
                    return false;
                }

                AuthApi.login(this.form.emailOrLogin, this.form.password).then(response => {
                    Auth.save(response.data['access-token'], true);

                    const toRedirect = this.$route.query.redirect;
                    if (toRedirect) {
                        this.$router.replace({path: toRedirect});
                    } else {
                        this.$router.replace({name: 'dashboard'});
                    }
                }).catch(error => {
                    if (error.response.status === 403) {
                        this.form.authError = true;
                    } else {
                        this.$router.push({
                            name: 'error',
                            params: {
                                code: error.response.status,
                                codeText: error.response.statusText,
                                message: error.response.data.message,
                                trace: error.response.data.type,
                            },
                        });
                    }
                });

            },
        },
        metaInfo() {
            return {
                title: 'Вход',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
